var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11309 22.5472L3.04297 23.4771L15.9805 19.1646L18.8555 10.5396L18.8869 10.5081L13.1369 4.75811L13.1055 4.78955L4.48047 7.66455L0.167969 20.6021L1.09785 21.5319L7.5666 15.0632C7.43184 14.7802 7.35547 14.4657 7.35547 14.1333C7.35547 12.9429 8.32129 11.9771 9.51172 11.9771C10.7021 11.9771 11.668 12.9429 11.668 14.1333C11.668 15.3237 10.7021 16.2896 9.51172 16.2896C9.1793 16.2896 8.86484 16.2132 8.58184 16.0784L2.11309 22.5472ZM14.1521 3.74287L19.9021 9.49287L23.168 6.22705L17.418 0.477051L14.1521 3.74287Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenRegular);
export default __webpack_public_path__ + "static/media/pen-regular.9d282e8bd3897daf83d1ce5b49cac51e.svg";
export { ForwardRef as ReactComponent };